import SectionWrapper from 'src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCheckout/SectionWrapper';
import React from 'react';
import css from './css.module.less';
import { get } from 'lodash';
import { OriCheckbox as Checkbox } from 'src/components/Antd/Checkbox/Checkbox';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const Fapiao = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { data, onChange, setHasModified } = props;
  const enabled = get(data, 'enabled');
  const handleOnChange = (e) => {
    setHasModified(true);
    const enabled = e.target.checked;
    if (onChange) {
      onChange({ enabled });
    }
  };
  return (
    <SectionWrapper
      subtitle={getI18n('salesChannelCheckout.index.chinaFapiaoSubTitle')}
      title={getI18n('salesChannelCheckout.index.chinaFapiaoTitle')}>
      <Checkbox
        checked={enabled}
        onChange={handleOnChange}
        className={css.checkbox}>
        {getI18n(
          'salesChannelCheckout.index.enablemainlandChinacheckoutFapiao',
        )}
      </Checkbox>
    </SectionWrapper>
  );
};
export default Fapiao;
